console.info('Designed by Giliance Cachin, gilianecachin.ch');
console.info('Developed by Frederik Mahler-Andersen, fm-a.dk');

import Alpine from "alpinejs";
import LazyLoad from 'vanilla-lazyload'
import collapse from '@alpinejs/collapse'
import AsyncAlpine from 'async-alpine';
import intersect from '@alpinejs/intersect'

Alpine.plugin(AsyncAlpine);

Alpine.asyncData('vimeoPlayer', () => import('./vimeoplayer.js'));
Alpine.asyncData('teaser', () => import('./teaser.js'));
Alpine.asyncData('gallery', () => import('./gallery.js'));
Alpine.asyncData('newsletter', () => import('./newsletter.js'));
Alpine.asyncData('seasons',	() => import('./seasons.js'));

window.lazyLoadInstance = new LazyLoad({
      elements_selector: '[loading=lazy]',
      use_native: true
})

Alpine.data('projectteaser', () => ({
    intensity: 100,
    onScroll(event) {
        const bounds = this.$el.getBoundingClientRect();
        const scrollTop = bounds.top;
        const windowHeight = window.innerHeight;
        const middleOfScreen = windowHeight / 2;
        
        if (scrollTop > windowHeight) {
            // Below fold - stay at 200
            this.intensity = 100;
        } else if (scrollTop <= middleOfScreen) {
            // Above middle of screen - stay at 500
            this.intensity = 500;
        } else {
            // Between middle and bottom of screen - interpolate from 500 to 100
            const progress = (scrollTop - middleOfScreen) / (windowHeight - middleOfScreen);
            this.intensity = 500 - (400 * progress);
        }
    }
}));

Alpine.data('search', () => ({
    active: false,
    query: '',
    openSearch() {
        this.active = !this.active; 
        setTimeout(() => {
            this.$refs.searchinput.focus();
        }, 100);
    },
    search() {
        if (this.query.length > 0) {
            this.active = false;
            const currentPath = window.location.pathname;
            const langPrefix = currentPath.match(/^\/(en|fr)/) ? currentPath.match(/^\/(en|fr)/)[0] : '';
            window.location.href = `${langPrefix}/search?query=${encodeURIComponent(this.query)}`;
        }
    }
}));



    
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();